import type { AccountId } from '@atlassian/jira-shared-types';
import type { Query } from '../../../model';
import type { State } from '../../types';

export const getAtlassianAccountId = (state: State): AccountId | undefined =>
	state.app.props.atlassianAccountId;
export const getBaseUrl = (state: State): string => state.app.props.baseUrl;
export const getIsAdmin = (state: State): boolean => state.app.props.isAdmin;
export const getOnQueryChanged = (state: State): ((arg1: Query) => void) =>
	state.app.props.onQueryChanged;
export const getXsrfToken = (state: State): string => state.app.props.xsrfToken;
export const isWithoutHeader = (state: State): boolean => state.app.props.withoutHeader;
export const isWithPageReadyMetrics = (state: State): boolean =>
	state.app.props.withPageReadyMetrics;
